import { axios_download_file, axios_post } from '@/assets/js/functions/axios_helpers.js';
import { ROUTE_FILE_DOWNLOAD, ROUTE_FILE_UPLOAD } from '@/assets/js/consts/apiRoutes.consts';

const upload_file = params => axios_post(ROUTE_FILE_UPLOAD, params);

const download_file = params => axios_download_file(ROUTE_FILE_DOWNLOAD, params);

export { upload_file, download_file };
